import React from "react";
import { classNames } from "maven-lib/dist/utils/misc";
import { CrIcon } from "./CrIcon";
import { CrRequestButton, CrRequestButtonProps } from "./CrRequestButton";
import { IconName } from "../interface/Icon";

interface HbButtonProps<TR, TE, TRR, TRE> extends Omit<CrRequestButtonProps<TR, TE, TRR, TRE>, "text" | "color" | "size"> {
  text: string | React.ReactNode;
  className?: string;
  color: "PRIMARY" | "DANGER" | "SUCCESS" | "WARNING";
  iconLeft?: IconName;
  iconRight?: IconName;
  marginTop?: -1;
  size?: "LARGE" | "X-LARGE" | "2X-LARGE" | "3X-LARGE" | "4X-LARGE" | "5X-LARGE" | "6X-LARGE" | "7X-LARGE" | "8X-LARGE";
  dialogTextSize?: "SMALL" | "MEDIUM" | "LARGE";
}

export function HbRequestButton<TR = any, TE = any, TRR = TR, TER = TE>(props: HbButtonProps<TR, TE, TRR, TER>) {
  const { className, color, marginTop, text, iconLeft, iconRight, size, dialogTextSize, ...extras } = props;

  return (
    <div
      tabIndex={-1}
      className={classNames(
        "hb-request-button",
        className,
        `--color-${String(color || "default").toLowerCase()}`,
        `--margin-top-${marginTop || "default"}`,
        `--size-${String(size || "default").toLowerCase()}`
      )}
    >
      <CrRequestButton {...extras} dialogTextSize={dialogTextSize}>
        {!!iconLeft && <CrIcon icon={iconLeft} />}
        <span>{text}</span>
        {!!iconRight && <CrIcon icon={iconRight} />}
      </CrRequestButton>
    </div>
  );
}

HbRequestButton.defaultProps = {
  color: "PRIMARY",
};
